import { useRouter } from 'next/router';
import { PAGE_MAPPING } from '../constants';
import { AD_UNIT_PAGES } from '../types';

export const getPageSuffix = (): AD_UNIT_PAGES => {
    const router = useRouter();
    const { route } = router;

    const page = Object.entries(PAGE_MAPPING).find((k) =>
        route.startsWith(k[0])
    );

    if (page === undefined) {
        console.log('UNKNOWN ad unit page. Please correct.');
        return AD_UNIT_PAGES.UNKNOWN;
    }

    return page[1];
};
